import React from 'react'
import PropTypes from 'prop-types'

const FontItalicControl = ({ canvas, active, disabled }) => {
  const activeClass = active ? 'active' : ''
  const disabledClass = disabled ? 'disabled' : ''

  const toggleUnderline = () => {
    const obj = canvas.getActiveObject()
    const isDefault = obj.underline

    obj.set('underline', !isDefault)
      .exitEditing()

    canvas.renderAll()
  }

  return (
    <div
      className={`letterHeaderTools_action icon icon-underline ${activeClass} ${disabledClass}`}
      onClick={toggleUnderline} />
  )
}

FontItalicControl.propTypes = {
  canvas: PropTypes.object,
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
}

export default FontItalicControl
